import { SupportedPlatforms } from '@smg-real-estate/domus';
import { type VueHeadClient } from '@unhead/vue/client';
import { type Pinia } from 'pinia';
import { type App, type Component } from 'vue';
import { type Router } from 'vue-router';

import { initI18n } from '@/i18n-setup';
import { createVueApp } from './createApp';

export async function createAppByPlatform(appComponent: Component): Promise<{
  app: App<Element>;
  router: Router;
  pinia: Pinia;
  head: VueHeadClient;
}> {
  const defaultTranslations = await import('@/i18n/de-hg');

  const i18n = initI18n(defaultTranslations.default);

  return createVueApp(appComponent, i18n, SupportedPlatforms.hg);
}
